import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'


const ProtectedGoogleAuth: FC = () => {
    const isGoogleAuth = localStorage.getItem("isGoogleAuth")

    return isGoogleAuth ? <Outlet /> : <Navigate to="/google-login" />
}

export default ProtectedGoogleAuth